exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".averageRate .name{\r\n    font-family: Roboto !important;\r\n}\r\n\r\n.rateParam a{\r\n   color: #fff !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/brand-profile/brand-profile.component.css
// module id = ../../../../../src/app/brand-profile/brand-profile.component.css
// module chunks = main